import { Stack, useTheme } from '@mui/material';
import React from 'react';
import { IIdP } from 'types/api';
import EllipsesTypography from './EllipsesTypography';
import IdPIcon from './IdPIcon';

interface IIdPChipProps {
	idp: IIdP;
}

const IdPChip: React.FC<IIdPChipProps> = ({ idp }) => {
	const {
		palette: {
			primary: { light: primaryLightColor }
		}
	} = useTheme();

	return (
		<Stack
			py={0.5}
			px={0.5}
			gap={0.5}
			direction="row"
			alignItems="center"
			data-testid="idp-chip"
			sx={{
				borderRadius: 1,
				backgroundColor: 'transparent',
				borderColor: primaryLightColor,
				borderStyle: 'solid',
				borderWidth: 1,
				overflow: 'hidden',
				minWidth: 80
			}}
		>
			<IdPIcon idp={idp} width={24} height={24} />
			<EllipsesTypography variant="body2">{idp.name}</EllipsesTypography>
		</Stack>
	);
};

export default IdPChip;
